// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/timeline-bundle.css
// module id = 960
// module chunks = 3